import React, { createContext, useContext, useMemo, useState } from 'react'

const NotificationsContext = createContext(null)

const useNotifications = () => {
  const context = useContext(NotificationsContext)
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationsProvider')
  }
  return context
}

const NotificationsProvider = props => {
  const [notifications, setNotifications] = useState(null)

  const value = useMemo(() => ({ notifications, setNotifications }), [notifications])
  return <NotificationsContext.Provider value={value} {...props} />
}

export { NotificationsProvider, useNotifications }
